const DataCleaningMethods = {
  SCORE_THRESHOLD: "SCORE_THRESHOLD",
  TARGET_SAMPLE: "TARGET_SAMPLE",
  QUOTA_TARGET: "QUOTA_TARGET",
  MANUAL: "MANUAL"
};

export default DataCleaningMethods;
